import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewportService } from 'src/app/services/viewport.service';
import {UserModel} from '../../../models/User';
import {Router} from '@angular/router';

@Component({
  selector: 'sms-warning-modal',
  templateUrl: './sms-warning-modal.component.html',
  styleUrl: './sms-warning-modal.component.css'
})
export class SmsWarningModalComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Input() user!: UserModel
  @Output() onClose = new EventEmitter<void>();

  constructor(
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      public viewport: ViewportService,
      public router: Router
  ) {}

  ngOnInit() {
      this.user = this.config.data.user
  }
  ngOnDestroy(): void {}

  hide() {
      this.onClose.emit();
  }

  close() {
      this.ref.close(); // this will destroy the dialog
  }
  upgrade() {
      this.router.navigate([this.user.upgradeLink], {
          queryParams: {
              upgrade_source: 'dashboard_sms_notifications',
              upgrade_campaign: '1_14_day_trial',
              upgrade_cohort: '2026'
          }
      });
      this.ref.close()
  }
}
